
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import {connect} from '../Notes/wrapper'
import { setAppLoadingState } from '../../state/settingsSlice';
import { getTotalCalculations, recordFusionCode,assignCartVersion } from '../../state/customerAsyncActions';
import { openAlert } from '../../state/customerSlice';
import { useLabels, useIsMexico, useIsPR, useInputDataState, isBusiness } from '../../functions';
import CartABLayout from './CartABLayout';
import CartClassicLayout from './CartClassicLayout';
import './cart.scss'



const Cart = () => {
  const labels = useLabels();
  const {
    plan,
    installDate,
    explainedPricing,
    resId,
    continuity,
    script,
    contactConsentBroadband,
    caseId = '',
  } = useSelector((state) => state.customer.data);

  const cart = useSelector(state => state.customer.cart);
  const cartState = useSelector(state => state.customer.cartState);
  const dispatch = useDispatch();
  const isMX = useIsMexico();
  const isPR = useIsPR();
  //const [version, setVersion] = useInputDataState('version');
  const [version, setVersion] = useState("A");
  const [abVersion, setAbVersion] = useState(null); 
  const InstallAlertPhoneConsent = useSelector(
    state => state.customer.data.InstallAlertPhoneConsent
  )

  const handleClick = async () => {
    if (!isBusiness(script) && !contactConsentBroadband && !isMX) {
      dispatch(openAlert(labels.consentToContactBroadbandRequired));
      return;
    }
    if (!isMX && installDate !== 'Bypass' && !resId) {
      dispatch(openAlert(labels.pleaseDoTheReservation));
      return;
    }
    if (!isMX && !isPR && !explainedPricing && continuity !== 'Continuity') {
      dispatch(openAlert(labels.pleaseExplainPricing));
      return;
    }
    if(!isMX){
      if(!version){
        const cartPreviewVersion = await dispatch(assignCartVersion(caseId));
        setVersion({ target: { value: cartPreviewVersion.payload } });
        setAbVersion(cartPreviewVersion.payload);
      }
      else{
        setAbVersion(version)
      }
    }
    
    
    dispatch(setAppLoadingState('pending'));
    await dispatch(getTotalCalculations());
    dispatch(recordFusionCode());
    dispatch(setAppLoadingState(''));
  };


  if (!plan) return null;
  const cartClassName = abVersion === 'B' ? 'cart-preview' : 'cart';
  const isCartButtonDisabled = InstallAlertPhoneConsent !== 'Y';
  return (
    <div className={cartClassName}>
      {cartState === 'done' &&
        (abVersion === 'B'
          ? <CartABLayout cart={cart} labels={labels} continuity={continuity} isPR={isPR} plan={plan} />
          : <CartClassicLayout cart={cart} labels={labels} continuity={continuity} isPR={isPR} />
        )
      }
      <Row className="mt-5 mb-3">
        <Col sm={12} md={{ span: 2, offset: 5 }}>
          <Button 
            onClick={handleClick}
            disabled={isCartButtonDisabled}

          >
            {cartState === 'done' ? labels.reloadCart : labels.loadCart}
          </Button>
        </Col>
      </Row>
    </div>
  );
};


export default connect(Cart, 'cart')
